import { ApiAttributionModel, ApiMetric } from "@incendium/api";
import { AttributionMetric } from "../analytics/types/types";

export const attributionMetrics = {
  [AttributionMetric.MACRO]: "Actual Conversions",
  [AttributionMetric.SALES]: "Actual Sales",
  [AttributionMetric.REVENUE]: "Actual Revenue",
  [AttributionMetric.ROI]: "Actual ROI",
  [AttributionMetric.ROAS]: "Actual ROAS",
  [AttributionMetric.PROFIT]: "Actual Profit",
  [AttributionMetric.NET_REVENUE]: "Actual Net Revenue",
};
export const attributionModels = {
  [ApiAttributionModel.EBA]: "EBA",
  [ApiAttributionModel.FIRST]: "First Click",
  [ApiAttributionModel.LAST]: "Last Click",
  [ApiAttributionModel.LAST_NON_DIRECT]: "Last Non-Direct",
  [ApiAttributionModel.LINEAR]: "Linear",
  [ApiAttributionModel.POSITION_BASED]: "Position",
  [ApiAttributionModel.IMPACTED]: "Impacted",
  [ApiAttributionModel.CUSTOM]: "Custom",
};
export const publisherConversions = {
  [ApiMetric.METRIC_PUBLISHER_CONVERSIONS]: "Publisher Conversions",
  [ApiMetric.METRIC_PUBLISHER_ALL_CONVERSIONS]: "All Publisher Conversions",
  [ApiMetric.METRIC_PUBLISHER_SALES_COUNT]: "Publisher Sales",
  [ApiMetric.METRIC_PUBLISHER_REVENUE]: "Publisher Revenue",
};

export const attributionApiMetrics = [
  ApiMetric.METRIC_MACRO_CONVERSIONS_COUNT_EBA,
  ApiMetric.METRIC_SALES_COUNT_EBA,
  ApiMetric.METRIC_REVENUE_EBA,
  ApiMetric.METRIC_ROAS_EBA,
  ApiMetric.METRIC_ROI_EBA,
  ApiMetric.METRIC_PROFIT_EBA,
  ApiMetric.METRIC_NET_REVENUE_EBA,
  ApiMetric.METRIC_CAC_EBA,

  ApiMetric.METRIC_MACRO_CONVERSIONS_COUNT_FIRST,
  ApiMetric.METRIC_SALES_COUNT_FIRST,
  ApiMetric.METRIC_REVENUE_FIRST,
  ApiMetric.METRIC_ROAS_FIRST,
  ApiMetric.METRIC_ROI_FIRST,
  ApiMetric.METRIC_PROFIT_FIRST,
  ApiMetric.METRIC_NET_REVENUE_FIRST,
  ApiMetric.METRIC_CAC_FIRST,

  ApiMetric.METRIC_MACRO_CONVERSIONS_COUNT_LAST,
  ApiMetric.METRIC_SALES_COUNT_LAST,
  ApiMetric.METRIC_REVENUE_LAST,
  ApiMetric.METRIC_ROAS_LAST,
  ApiMetric.METRIC_ROI_LAST,
  ApiMetric.METRIC_PROFIT_LAST,
  ApiMetric.METRIC_NET_REVENUE_LAST,
  ApiMetric.METRIC_CAC_LAST,

  ApiMetric.METRIC_MACRO_CONVERSIONS_COUNT_LAST_NON_DIRECT,
  ApiMetric.METRIC_SALES_COUNT_LAST_NON_DIRECT,
  ApiMetric.METRIC_REVENUE_LAST_NON_DIRECT,
  ApiMetric.METRIC_ROAS_LAST_NON_DIRECT,
  ApiMetric.METRIC_ROI_LAST_NON_DIRECT,
  ApiMetric.METRIC_PROFIT_LAST_NON_DIRECT,
  ApiMetric.METRIC_NET_REVENUE_LAST_NON_DIRECT,
  ApiMetric.METRIC_CAC_LAST_NON_DIRECT,

  ApiMetric.METRIC_MACRO_CONVERSIONS_COUNT_LINEAR,
  ApiMetric.METRIC_SALES_COUNT_LINEAR,
  ApiMetric.METRIC_REVENUE_LINEAR,
  ApiMetric.METRIC_ROAS_LINEAR,
  ApiMetric.METRIC_ROI_LINEAR,
  ApiMetric.METRIC_PROFIT_LINEAR,
  ApiMetric.METRIC_NET_REVENUE_LINEAR,
  ApiMetric.METRIC_CAC_LINEAR,

  ApiMetric.METRIC_MACRO_CONVERSIONS_COUNT_POSITION_BASED,
  ApiMetric.METRIC_SALES_COUNT_POSITION_BASED,
  ApiMetric.METRIC_REVENUE_POSITION_BASED,
  ApiMetric.METRIC_ROAS_POSITION_BASED,
  ApiMetric.METRIC_ROI_POSITION_BASED,
  ApiMetric.METRIC_PROFIT_POSITION_BASED,
  ApiMetric.METRIC_NET_REVENUE_POSITION_BASED,
  ApiMetric.METRIC_CAC_POSITION_BASED,

  ApiMetric.METRIC_MACRO_CONVERSIONS_COUNT_IMPACTED,
  ApiMetric.METRIC_SALES_COUNT_IMPACTED,
  ApiMetric.METRIC_REVENUE_IMPACTED,
  ApiMetric.METRIC_ROAS_IMPACTED,
  ApiMetric.METRIC_ROI_IMPACTED,
  ApiMetric.METRIC_PROFIT_IMPACTED,
  ApiMetric.METRIC_NET_REVENUE_IMPACTED,
  ApiMetric.METRIC_CAC_IMPACTED,

  ApiMetric.METRIC_MACRO_CONVERSIONS_COUNT_CUSTOM,
  ApiMetric.METRIC_SALES_COUNT_CUSTOM,
  ApiMetric.METRIC_REVENUE_CUSTOM,
  ApiMetric.METRIC_ROAS_CUSTOM,
  ApiMetric.METRIC_ROI_CUSTOM,
  ApiMetric.METRIC_PROFIT_CUSTOM,
  ApiMetric.METRIC_NET_REVENUE_CUSTOM,
  ApiMetric.METRIC_CAC_CUSTOM,
];
